import { EyengageFilterCategories, EyengagePost, EyengageSettings, EyengageStateType, Pagination, Poll } from "src/shared/types/src";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: EyengageStateType = {
    isLoading: false,
    paginatedLoading: false,
    posts: [],
    pagination: {
        currentPage: 1,
        from: 1,
        itemsPerPage: 0,
        lastPage: 1,
        to: 1,
        totalItems: 1
    },
    isEyengageFilterApplied: false,
    settings: undefined,
    filterCategories: [],
    selectedPostTypeFilter: [],
    selectedCategoryFilter: {},
    eyManSettingsLoading: false
}

const eyengageSlice = createSlice({
    name: 'eyengageSlice',
    initialState,
    reducers: {
        setPostsLoader: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
        setPostsPaginatedLoader: (state, action: PayloadAction<{ paginatedLoading: boolean }>) => {
            state.paginatedLoading = action.payload.paginatedLoading;
        },
        appendEyengagePosts: (state, action: PayloadAction<{ posts: EyengagePost[], pagination: Pagination, settings: EyengageSettings }>) => {
            state.pagination = action.payload.pagination;
            state.settings = action.payload.settings;
            // const newPosts = action.payload.posts;
            // newPosts.forEach((post) => {
            //     const idx = state.posts.findIndex((p) => p.id === post.id);
            //     if (idx === -1)
            //         state.posts.push(post);
            // })
            state.posts = [...state.posts, ...action.payload.posts];
            // state.posts.push(...action.payload.posts);
        },
        resetEyengageState: () => {
            return { ...initialState, isLoading: true }
        },
        resetEyengagePostsState: (state) => {
            return {
                ...initialState,
                isLoading: true,
                isEyengageFilterApplied: state.isEyengageFilterApplied,
                selectedPostTypeFilter: state.selectedPostTypeFilter
            }
        },
        updateCommentCountInPostById: (state, action: PayloadAction<{ postId: string, updatedCommentCount: number }>) => {
            const { postId, updatedCommentCount } = action.payload;
            const postList = state.posts;
            const postIndex = state.posts.findIndex((p) => p.id === postId);
            if (postIndex === -1)
                return;

            const updatedObj: EyengagePost = { ...postList[postIndex], comments: { ...postList[postIndex].comments, count: updatedCommentCount } };
            state.posts = [
                ...postList.slice(0, postIndex),
                updatedObj,
                ...postList.slice(postIndex + 1),
            ];
        },
        updateLikeCountInPostById: (state, action: PayloadAction<{ postId: string, updatedLikeCount: number, likedBySelf: boolean }>) => {
            const { postId, updatedLikeCount, likedBySelf } = action.payload;
            const postList = state.posts;
            const postIndex = state.posts.findIndex((p) => p.id === postId);
            if (postIndex === -1)
                return;

            const updatedObj: EyengagePost = { ...postList[postIndex], likes: { ...postList[postIndex].likes, count: updatedLikeCount, self: likedBySelf } };
            state.posts = [
                ...postList.slice(0, postIndex),
                updatedObj,
                ...postList.slice(postIndex + 1),
            ];
        },
        updateConfirmPostDataInPostById: (state, action: PayloadAction<{ postId: string, updatedConfirmByMe: boolean, confirmedAt: string }>) => {
            const { postId, updatedConfirmByMe, confirmedAt } = action.payload;
            const postList = state.posts;
            const postIndex = state.posts.findIndex((p) => p.id === postId);
            if (postIndex === -1)
                return;

            const updatedObj: EyengagePost = { ...postList[postIndex], confirmedByMe: updatedConfirmByMe, confirmedAt };
            state.posts = [
                ...postList.slice(0, postIndex),
                updatedObj,
                ...postList.slice(postIndex + 1),
            ];
        },
        updatePollDataInPostById: (state, action: PayloadAction<{ postId: string, updatedPoll: Poll }>) => {
            const { postId, updatedPoll } = action.payload;
            const postList = state.posts;
            const postIndex = state.posts.findIndex((p) => p.id === postId);
            if (postIndex === -1)
                return;

            const updatedObj: EyengagePost = { ...postList[postIndex], poll: updatedPoll };
            state.posts = [
                ...postList.slice(0, postIndex),
                updatedObj,
                ...postList.slice(postIndex + 1),
            ];
        },
        setIsEyengageFilterApplied: (state, action: PayloadAction<boolean>) => {
            state.isEyengageFilterApplied = action.payload
        },
        setFilterCategories: (state, action: PayloadAction<EyengageFilterCategories[]>) => {
            console.log("filter set categories XXX : ", action.payload);
            state.filterCategories = action.payload;
        },
        setEymanSettingsLoader: (state, action: PayloadAction<{ settingsLoading: boolean }>) => {
            state.eyManSettingsLoading = action.payload.settingsLoading;
        },
        setPostTypeFilter: (state, action: PayloadAction<string[]>) => {
            console.log("setting selected type filter : ", action.payload);
            state.selectedPostTypeFilter = action.payload;
        },
        setPostCategoryFilter: (state, action: PayloadAction<Object>) => {
            state.selectedCategoryFilter = action.payload;
        },
    }
});

export const EyengageActions = eyengageSlice.actions;
export default eyengageSlice.reducer;